<div class="container">

  <!-- HEADER -->
  <header class="header">
    <h1>TUTORÍAS</h1>
  </header>

  <!-- IMAGEN / LOGO -->
  <section class="hero">
    <div class="hero-card">
      <img src="assets/img_plataformas/tutorias.png" alt="Tutorías">
    </div>
  </section>

  <!-- INFORMACIÓN -->
  <section class="info">

    <h3>INFORMACIÓN</h3>

    <p>
      La Tutoría es el proceso de acompañamiento grupal o individual que se le brinda a la comunidad estudiantil, a través de un tutor(a)
       durante su instancia en el Instituto Tecnológico; con el propósito de contribuir a su formación integral que le permita el mejoramiento
        de su desempeño académico y la toma de decisiones sobre su vida académica, personal o social. 
      
    </p>

    <p>
    
      Este es un programa de complementación a tu formación, el cual tiene como características: 
    </p>

    <h4>Características del programa:</h4>
    <ul>
      <li>Tutor(a) asignado por grupo</li>
      <li>Sesiones grupales de una hora semanal</li>
      <li>Un crédito como valor reticular</li>
    </ul>

    <p>
      Este programa se está implementado en los grupos de primer semestre, sin embargo, si eres alumno(a) de semestre avanzado también puedes recibir apoyo tutorial en el área que lo requieras,
      puedes acudir a tu coordinación o directamente a Desarrollo Académico, te esperamos. 
    </p>

    <h4>Participantesen el proceso:</h4>
    <ul>
      <li>Subdirección Académica</li>
      <li>Jefes(as) de departamento</li>
      <li>Coordinadores(as)</li>
      <li>Tutores(as)</li>
      <li>Docentes</li>
      <li>Tutorados(as) alumnos(as)</li>
    </ul>

    <!-- LINK SISTEMA -->
    <a href="https://ti.itsescarcega.edu.mx/pruebas_itse/" class="system-link">SISTEMA DE TUTORÍAS INTERNO</a>

    <!-- LOGIN COMO IMAGEN -->
    <div class="login-img-container">
      <img src="assets/img_plataformas/tutiriasistem.jpg" alt="Login Tutorías">
    </div>
<br>
    <!-- RESPONSABLE -->
    <div class="extra-info">
      <p><b>RESPONSABLE:</b><br> Psic. Dayreli Delfina Mena Gallegos</p>

      <p><b>HORARIO DE ATENCIÓN:</b><br>
      Lunes a Viernes de 10:00 - 15:00 hrs.</p>
    </div>



  </section>


</div>